import { UntypedFormGroup } from "@angular/forms";
import { Observable } from "rxjs";

export abstract class AbStep {
  abstract unidadeForm: UntypedFormGroup;
  abstract blocoForm: UntypedFormGroup;
  abstract blocoLazy: boolean;
  abstract configBlocoLazy: boolean;
  abstract blocoCompleted: boolean;
  abstract configBlocoCompleted: boolean;
  abstract tipoConta: any;
  static valorAcimaDeZero;
  abstract getBlocoCompleted(): boolean;
  abstract getConfigBlocoCompleted(): boolean;
  abstract setBlocoCompleted(completed: boolean): Observable<any>;
  abstract setConfigBlocoCompleted(completed: boolean): Observable<any>;
  abstract observableCompleted(): Observable<boolean>;
}